import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useAppContext } from '../../../hooks/AppContext';
import { segmentTracking } from '../../../lib/tracker';
import envizi from '../../../data/envizi.json';
import { Button, ModalWrapper, Tooltip } from 'carbon-components-react';
import { segmentsTracking } from 'src/common/lib/tracker';
import Footnote from '../../Molecules/Footnote/Footnote';
import {
  EST_ACCT_LIMIT,
  Pkg,
  QuesSet1,
  QuesSet2,
  QuesSet3,
  STD_ACCT_LIMIT,
  UT30Envzi,
} from 'src/apps/envizi-price-estimator/constant/spread';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';
import { useEnv } from 'src/common/hooks/widgets/useEnv';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import * as URX_FORM from '../../../constant/urx-form';
import { useBPName } from 'src/common/hooks/widgets/useBPName';
import { FormModal } from 'src/common/utils/FormModal';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import ModalThanks from '../../Molecules/Thanks/ModalThanks';
import countryList from '../../../services/currencies.json';
import {
  LangDefaults,
  determineCountry,
  useLang,
} from 'src/common/hooks/widgets/useLang';
import DisclaimerText from 'src/common/components/DisclaimerText/DisclaimerText';
import { createUseTranslation } from '../../../../../common/hooks/widgets/useTranslation';
import { useEnviziSelector } from '../../../lib/redux/hooks';
import Step1 from '../../Molecules/Steps/Step1';
import { getSelectedAnswer } from '../../../utility';
import { prop, isEmpty, propOr } from 'ramda';
import Step2 from '../../Molecules/Steps/Step2';
import Step3 from '../../Molecules/Steps/Step3';
import Step4 from '../../Molecules/Steps/Step4';
import Step5 from '../../Molecules/Steps/Step5';
import Result from '../../Molecules/Result/Result';
import { ArrowRight20, Restart20 } from '@carbon/icons-react';
import Thanks from '../../Molecules/Thanks/Thanks';
import { shortcode } from 'src/apps/envizi-price-estimator/EnviziPriceEstimator.widget';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';

type HomePageProps = {
  tileValue: string;
  setTileValue: React.Dispatch<React.SetStateAction<string>>;
  langCode: string;
  countryToTest: string;
  test: boolean;
  shortcode: string;
};

const HomePage = ({
  tileValue,
  setTileValue,
  langCode,
  countryToTest,
  test,
  shortcode,
}: HomePageProps) => {
  const { appState, appAction } = useAppContext();
  const [packageName, setPackageName] = useState('');
  const [appPoints, setAppPoints] = useState(0);
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [urxlang] = useState(localeCode.toString());
  const isSmall = useSmallBreakpoint('1030px');
  const [showPrice, setShowPrice] = useState(false);
  const [showPkg, setShowPkgDesc] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [formComplete, setFormComplete] = useState(false);
  const [buyThanksModal, setBuyThanksModal] = useState(false);
  const [environment] = useEnv();
  const cookieURL = useCookiesURL(shortcode);
  const sourceConnRef = useRef() as MutableRefObject<HTMLInputElement>;
  const { bpName, companyId, logo } = useBPName(UT30Envzi, true);
  const [currency, setCurrency] = useState('');
  const [country, setCountry] = useState('');
  const AEMMessages = useEnviziSelector((state) => state.translations.messages);
  const useTranslation = createUseTranslation(messages, AEMMessages);
  const [compliance, setCompliance] = useState('');
  const value = getSelectedAnswer(appState);
  const q1Val = Number(value[0]?.answer.split(' ')[0].split('-')[1]);
  const q2Val = Number(value[1]?.answer.split(' ')[0]);
  const totalValue = q1Val * q2Val;
  const submitted = prop('submitted')(appState);
  const scope3Option = prop('scope3')(appState);
  const answered1 = QuesSet1.every((key) => key in submitted);
  const answered2 = QuesSet2.every((key) => key in submitted);
  const answered3 = QuesSet3.every((key) => key in submitted);
  const checkQ3Option = ['Q3'].every((key) => key in submitted);
  const q3Values = checkQ3Option && submitted['Q3'];
  const gasValue = Object.values(q3Values)[0] as string;
  const gasAns = !isEmpty(gasValue) && gasValue?.split(' Cookie-')[0];
  // lang and userlocale is based out of ddo
  const [lang, userLocale] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );
  const [localCurrency, setlocalCurrency] = useState<string>(localeCode);

  const [toggleCountry, setToggleCountry] = useState(false);
  const [modalLocalCountry, setModalLocalCountry] = useState('');
  const [modalLocalCurrency, setModalLocalCurrency] = useState('USD');
  const [modalLocalLanguage, setModalLocalLanguage] = useState('English');
  const [subQueState, setSubQueState] = useState(false);
  const [scopeOption, setScopeOption] = useState('');
  const [formId, setFormId] = useState('');

  const [localExist, setLocalExist] = useState(false);
  let localStorageFound = localStorage.getItem('langLocale');
  if (localStorageFound === null)
    localStorageFound = LangDefaults.localCountryLang;
  const [selectedLocale, setSelectedLocale] = useState(localStorageFound);

  // Determine Country
  determineCountry(
    setLocalExist,
    setSelectedLocale,
    setModalLocalCountry,
    setModalLocalLanguage,
    setModalLocalCurrency,
    setToggleCountry,
    lang,
    countryList,
    true,
    test,
    localeCode,
  );

  useEffect(() => {
    setlocalCurrency(userLocale); // show local Currency
  }, [userLocale, localeCode, localCurrency]);

  useEffect(() => {
    fetch(
      'https://ace-project-bucket.s3.us-east.cloud-object-storage.appdomain.cloud/production/envizi-estimator/envizi.json',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      },
    )
      .then((res) => res.json())
      .then((data) =>
        appAction({
          type: 'appData',
          data: data,
        }),
      )
      .catch((error) => {
        // loading the json file in case if we have any api issue
        if (error) {
          appAction({
            type: 'appData',
            data: envizi,
          });
        }
      });
  }, []);

  window.urxEnvironment = environment;
  window.onUrxFormSubmitSuccess = () => {
    setFormComplete(!formComplete);
    setDrawerOpen(false); // Hide Drawer on Thank you page
    window.location.reload(); // temp fix for modal issue
  };

  type ansProps = {
    id: string;
    state: string;
    answer: string;
  };

  const getAns: ansProps[] = getSelectedAnswer(appState);
  const checkCalcBtnState =
    (answered1 && gasAns === 'No') ||
    (answered2 && gasAns === 'Yes' && scope3Option === 'Yes') ||
    (answered3 && gasAns === 'Yes' && scope3Option === 'No')
      ? false
      : true;
  const handlePrice = () => {
    if ((answered1 || answered2 || answered3) && !showPrice) {
      setShowPrice(true);
      segmentsTracking('CTA Clicked', {
        pageTitle: 'Envizi Pricing Page',
        object: 'Pricing page',
        resultValue: 'CTA clicked',
        CTA: 'Calculate',
        location: 'Estimator',
        action: '',
        field: '',
      });
    } else if (showPrice) {
      segmentsTracking('CTA Clicked', {
        pageTitle: 'Envizi Pricing Page',
        object: 'Pricing page',
        resultValue: 'CTA clicked',
        CTA: 'Start over',
        location: 'Estimator',
        action: '',
        field: '',
      });
      setShowPrice(false);
      appAction({
        type: 'reset',
        answerId: '',
        answerValue: false,
      });
      appAction({
        type: 'start',
        answerId: '',
        answerValue: false,
      });
      window.location.reload();
    }
  };

  const requestQuote = (setCookie: any, cta: string) => {
    if (cta === messages.buy_btn_label.defaultMessage) {
      setBuyThanksModal(true);
    } else {
      setBuyThanksModal(false);
    }
    segmentsTracking('CTA Clicked', {
      pageTitle: 'Envizi Pricing Page',
      object: 'Pricing page',
      resultValue: 'CTA clicked',
      CTA: cta,
      location: 'Estimator',
      action: '',
      field: '',
    });
    initUrxForm(
      environment,
      URX_FORM.INSTANCE_ID,
      URX_FORM.FORM_ID,
      urxlang as IBMLocale,
      companyId,
      shortcode,
      setFormId,
    );
    setDrawerOpen(true);
    setCookie();
  };

  useEffect(() => {
    totalValue <= EST_ACCT_LIMIT
      ? setPackageName(Pkg.est)
      : totalValue > EST_ACCT_LIMIT && totalValue <= STD_ACCT_LIMIT
      ? setPackageName(Pkg.std)
      : setPackageName(Pkg.prem);
  }, [totalValue]);

  const price = prop('price')(appState);
  const { lowerPrice, higherPrice } = price;

  return (
    <>
      {formComplete ? (
        buyThanksModal ? (
          <ModalThanks
            lowerPrice={`${lowerPrice}`}
            higherPrice={`${higherPrice}`}
            packageName={packageName}
            bpName={bpName}
          />
        ) : (
          <Thanks bpName={bpName} />
        )
      ) : (
        <div className="bx--grid">
          <div className="bx--row modal-mt">
            <div
              className="bx--col-lg-4 bx--col-md-8 bx--col-sm-8 bx--offset-lg-12"
              id="countryModal"
            >
              {localExist && toggleCountry ? (
                <ModalWrapper
                  modalLabel={`Found country ${modalLocalCountry}. Access page in ${modalLocalLanguage} (${modalLocalCurrency})`}
                  modalHeading={`The Envizi Price estimator is available in ${modalLocalLanguage} with local currency ${modalLocalCurrency}`}
                  size={'sm'}
                  primaryButtonText={'Cool! Take me there'}
                  secondaryButtonText={'Stay here'}
                  buttonTriggerText={`Access page in ${modalLocalLanguage}`}
                  handleOpen={() => {
                    segmentTracking('CTA Clicked', {
                      pageTitle: 'Envizi Price Estimator',
                      object: 'Envizi page',
                      resultValue: 'CTA clicked',
                      CTA: 'Access Button for globalization',
                      location: 'Estimator',
                      action: '',
                      field: '',
                    });
                  }}
                  handleSubmit={() => {
                    localStorage.setItem('langLocale', selectedLocale);
                    (window.location.href =
                      'https://www.ibm.com/' +
                      selectedLocale +
                      '/products/envizi/pricing'),
                      segmentTracking('CTA Clicked', {
                        pageTitle: 'Envizi Price Estimator',
                        object: 'Envizi page',
                        resultValue: 'CTA clicked',
                        CTA: 'Switched to country ' + modalLocalCountry,
                        location: 'Estimator',
                        action: '',
                        field: '',
                      });
                    return true;
                  }}
                ></ModalWrapper>
              ) : null}
            </div>
          </div>
          <div className="bx--row mar3">
            <div className="bx--col-lg-12 bx--col-md-16 bx--col-sm-4">
              <div className="page_heading_2">{useTranslation('heading')}</div>
              <div className="page_body marTop">
                {useTranslation('sub_heading')}
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-5 bx--col-md-5 bx--col-sm-4">
                  <Step1
                    isOpen={true}
                    compliance={compliance}
                    showPrice={showPrice}
                  />
                </div>
                <div className="bx--col-lg-5 bx--col-md-5 bx--col-sm-4">
                  <Step2 isOpen={true} showPrice={showPrice} q1Val={q1Val} />
                </div>
              </div>
              <hr className="hr-line" />
              <div className="bx--row mar3">
                <div className="bx--col-lg-12 bx--col-md-16 bx--col-sm-4">
                  <div className="page_body">
                    {useTranslation('sub_heading_2')}
                  </div>
                </div>
                <div className="bx--col-lg-5 bx--col-md-16 bx--col-sm-4">
                  <Step3
                    isOpen={true}
                    subQueState={subQueState}
                    setSubQueState={setSubQueState}
                    scopeOption={scopeOption}
                    setScopeOption={setScopeOption}
                    showPrice={showPrice}
                  />
                </div>
                {scopeOption === 'Yes' && (
                  <div className="bx--col-lg-5 bx--col-md-16 bx--col-sm-4 wrapper">
                    <div id="slide">
                      <Step4
                        isOpen={true}
                        setCompliance={setCompliance}
                        showPrice={showPrice}
                      />
                    </div>
                  </div>
                )}
                <div
                  className={`bx--col-lg-5 bx--col-md-16 bx--col-sm-4 ${
                    scopeOption ? 'fade-in' : ''
                  }`}
                >
                  <Step5 isOpen={true} showPrice={showPrice} />
                </div>
              </div>
            </div>
            {!showPkg && (
              <div className="bx--col-lg-4 bx--col-md-16 bx--col-sm-4 mar3">
                <div className="recommend mar-2rm">
                  <div className="page_body ibm-mb-1">
                    {useTranslation('box_description')}
                  </div>
                  <Button
                    id="show price"
                    className="btn-style"
                    onClick={() => setShowPkgDesc(true)}
                    renderIcon={!showPrice ? ArrowRight20 : Restart20}
                    disabled={!q1Val && !q2Val}
                  >
                    {useTranslation('calc_btn_label')}
                  </Button>
                </div>
              </div>
            )}
            {showPkg && (
              <div className="bx--col-lg-4 bx--col-md-16 bx--col-sm-4">
                <Result
                  langCode={langCode}
                  isOpen={true}
                  answers={getAns}
                  tileValue={tileValue}
                  test={test}
                  countryToTest={countryToTest}
                  requestQuote={requestQuote}
                  totalValue={isNaN(totalValue) ? 0 : Math.round(totalValue)}
                  showPrice={showPrice}
                  checkCalcBtnState={checkCalcBtnState}
                  handlePrice={handlePrice}
                  formId={formId}
                />
              </div>
            )}
          </div>
          <div className="bx--row disclaimer">
            <div className="bx--col-lg-12 bx--col-md-16 bx--col-sm-4">
              <div>
                <Footnote numNote={1} />
              </div>
              <div className="footnote_text">
                <DisclaimerText localeCode={'us-en'} product={'Envizi'} />
              </div>
            </div>
          </div>
        </div>
      )}
      <FormModal
        pageTitle="Envizi Price Estimator"
        object="Envizi Price Estimator Page"
        productTitle={'Envizi Price Estimator'}
        pageUrl={''}
        location={'Estimator'}
        bpName={bpName}
        logo={logo}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        formId={formId}
        lang={lang}
      ></FormModal>
    </>
  );
};

export default HomePage;
